import { render } from "./AuthTgButton.vue?vue&type=template&id=7a831d99"
import script from "./AuthTgButton.vue?vue&type=script&lang=js"
export * from "./AuthTgButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__